import { render, staticRenderFns } from "./SalabamTravelTrain.vue?vue&type=template&id=12712b62&scoped=true"
import script from "./SalabamTravelTrain.vue?vue&type=script&lang=js"
export * from "./SalabamTravelTrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12712b62",
  null
  
)

export default component.exports